import { sendTeacherAmplitudeEvent } from '~analytics/amplitude';

import { EventTypes } from '../types';
import { EventAdapter } from './EventAdapter';

type CreateCheckoutSessionEventData = {
  source: 'pricing_table';
  team_id: string;
};

export class CreateCheckoutSessionEventAdapter extends EventAdapter<CreateCheckoutSessionEventData> {
  protected intercomEventKey = null;
  protected amplitudeEventFunction = function sendEventData(
    event: CreateCheckoutSessionEventData
  ) {
    sendTeacherAmplitudeEvent(EventTypes.CreateCheckoutSession, event);
  };

  constructor({ source, team_id }: CreateCheckoutSessionEventData) {
    super();
    this.eventData = {
      source,
      team_id,
    };
  }
}
